import React from 'react';
import { Box, Fade, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface OverlayProps {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  backgroundColor?: string;
  zIndex?: number;
}

const Overlay: React.FC<OverlayProps> = ({
  open,
  onClose,
  children,
  showCloseButton = true,
  backgroundColor = 'white',
  zIndex = 1000,
}) => {
  if (!open) return null;

  return (
    <Fade in={open} timeout={300}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor,
          zIndex,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {showCloseButton && onClose && (
          <Box
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              zIndex: zIndex + 1,
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: 'black',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        )}

        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Box>
      </Box>
    </Fade>
  );
};

export default Overlay;
